import { useCallback } from 'react';

import { useCheckImage, useUploadOcrImage, UploadOcrImageParams } from '../api';

const DEFAULT_STATUS_CHECK_DELAY_MS = 1500;

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const useUploadImageWithCheck = () => {
  const { mutateAsync: upload } = useUploadOcrImage();
  const { mutateAsync: checkImage } = useCheckImage();

  const uploadWithCheck = useCallback(
    async (uploadParams: UploadOcrImageParams) => {
      const uploadResult = await upload(uploadParams);
      await delay(DEFAULT_STATUS_CHECK_DELAY_MS);
      const checkResult = await checkImage({
        transactionId: uploadResult.transactionId,
        signal: uploadParams.signal,
      });
      if (checkResult.status === 'ERROR') {
        throw new Error(checkResult.message);
      }
      return uploadResult;
    },
    [upload, checkImage]
  );

  return { uploadWithCheck };
};
